module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "servicesRDV"
    }
  }, [_c('h2', [_vm._v(" Servicios con cita ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Cirugía")]), _vm._v(" "), _c('p', [_vm._v("Cirugía de tejidos blandos")]), _vm._v(" "), _c('p', [_vm._v("Ovariectomía")]), _vm._v(" "), _c('p', [_vm._v("Castración")]), _vm._v(" "), _c('p', [_vm._v("Odontología")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consulta")]), _vm._v(" "), _c('p', [_vm._v("Enfoque global basado en la nutrición y el comportamiento para\n             para lograr juntos el bienestar de tu compañero.")]), _vm._v(" "), _c('p', [_vm._v("Consultas homeopáticas")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Meseta técnica")]), _vm._v(" "), _c('p', [_vm._v("Ecografía")]), _vm._v(" "), _c('p', [_vm._v("Radiografía")]), _vm._v(" "), _c('p', [_vm._v("Hematología")]), _vm._v(" "), _c('p', [_vm._v("Bioquímica")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfcf98c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Es/ServicesRDV.vue
// module id = 150
// module chunks = 0